// Custom Styles
export const DataStyles = {
    headRow: {
        style: {
            background: "linear-gradient(to right, #9333EA, #EC4899)",
        },
    },
    headCells: {
        style: {
            color: "#fff", // Equivalent to text-white
            fontWeight: "bold",
            fontSize: "14px",
        },
    },
};
